export default {
  mmap: {
    "AC Masthead 01": require("./modules/Masthead01"),
    "AC Masthead 02": require("./modules/Masthead02"),
    "AC Masthead 03" : require("./modules/Masthead03"),
    "AC Masthead 04" : require("./modules/Masthead04"),
    "AC Footer 01": require("./modules/Footer/Footer01"),
    "AC Footer 02": require("./modules/Footer/Footer02"),
    "AC Footer 03": require("./modules/Footer/Footer03"),
    "AC Footer 04": require("./modules/Footer/Footer04"),
    "AC Tray 01": require("./modules/Tray/Video"),
    "AC Tray 06": require("./modules/Tray/FitnessMoreInfo"),
    "AC Tray 07": require('./modules/Tray/Concept'),
    "AC NetflixTray 01": require("./modules/Tray/Video/netflix-tray"),
    "AC Tray 08": require("./modules/Tray/Video/category-tray"),
    "AC ScheduleCarousel 01": require('./modules/Carousel/scheduleCarousel'),
    "AC EventCarousel 03": require("./modules/LiveSchedule"),
    "AC SearchFilter 02": require("./modules/BrowseConcepts"),
    "AC EventCarousel 04": require("./modules/LiveSchedule02"),
    "AC Carousel 02" : require('./modules/Carousel/PersonCarousel'),
    "AC Carousel 03" : require('./modules/Carousel/conceptCarousel'),
    "AC BrandTray 01": require('./modules/Tray/Brand'),
    "AC Following 01": require('./modules/Following'),
    // HACK TRAY ONLY FOR SHOWING SHOWS ON WEB ONLY AND NOT APPS
    // PLEASE DELETE THIS ONCE WE LAUNCH SHOWS FOR OTHER PLATFORMS
    'AC Tray XX': require('./modules/Tray/Video'),
    'AC Tray 02': require('./modules/Tray/Video/sports-template-tray'),
    'AC PreviewTray 01': require('./modules/Tray/Video/preview-tray'),
    'AC Carousel 01': require('./modules/Carousel'),
    'AC FullWidthCarousel 01': require('./modules/FullWidthCarousel'),
    'AC EventCarousel 01': require('./modules/Carousel/Event'),
    'AC RichText 01': require('./modules/RichText'),
    'AC RawHtml 01': require('./modules/RawHtml'),
    'AC WebFrame 01': require('./modules/WebFrame01'),
    'AC WebFrame 02': require('./modules/WebFrame02'),
    'AC WebFrame 03': require('./modules/WebFrame02'),
    'AC Grid 01': require('./modules/CategoryPage'),
    'AC Watchlist 01': require('./modules/Watchlist'),
    'AC History 01': require('./modules/History'),
    'AC VideoPlayerWithInfo 01': require('./modules/VideoPlayerWithInfo01'),
    'AC VideoPlayerWithInfo 02': require('./modules/VideoPlayerWithInfo02'),
    'AC VideoPlayerWithInfo 03': require('./modules/VideoPlayerWithInfo03'),
    'AC VideoPlayerWithInfo 04': require('./modules/VideoPlayerWithInfo04'),
    'AC StandaloneVideoPlayer 01': require('./modules/StandaloneVideoPlayer/StandaloneVideoPlayer01'),
    'AC UserManagement 01': require('./modules/User'),
    'AC UserManagement 02': require('./modules/User'),
    'AC ResetPassword 01': require('./modules/ResetPassword'),
    'AC CreatePassword 01': require('./modules/CreatePassword'),
    'AC ContinueWatching 01': require('./modules/ContinueWatching'),
    'AC ContinueWatching 02': require('./modules/WatchHistoryHorizontal'),
    'AC SelectPlan 01': require('./modules/SelectPlans01'),
    'AC SelectPlan 02': require('./modules/SelectPlans02'),
    'AC RedeemOffer 01': require('./modules/RedeemOffer'),
    'AC ImageTextRow 01': require('./modules/ImageTextRow'),
    'AC ShowDetail 01': require('./modules/ShowPage'),
    'AC ShowDetail 04': require('./modules/ConceptDetail'),
    'AC Banner 01': require('./modules/TeamMasthead'),
    'AC BannerAd 01': require('./modules/BannerAd'),
    'AC EmbeddedVideoPlayer 01': require('./modules/EmbedPlayer'),
    'AC ArticleTray 01': require('./modules/Tray/Article'),
    'AC ArticleDetail 01': require('./modules/Article'),
    'AC PhotoGallery 01': require('./modules/PhotoGallery'),
    'AC EventCalendar 01': require('./modules/Events'),
    'AC ArticleFeed 01': require('./modules/StackedArticles'),
    'AC CarouselWithList 01': require('./modules/ModulesContainer'),
    'AC EventDetail 01': require('./modules/EventDetail'),
    'AC SmallEventCalendar 01': require('./modules/SmallCalendar'),
    'AC MediumRectangleAd 01': require('./modules/MediumRectangleAd'),
    'AC GameDetail 01': require('./modules/SportEvent'),
    'AC FightDetail 01': require('./modules/SportEvent'),
    'AC TeamDetail 01': require('./modules/TeamDetail'),
    'AC TeamStats 01': require('./modules/TeamStats'),
    'AC TeamRoster 01': require('./modules/TeamRoster'),
    'AC PersonDetail 01': require('./modules/PersonDetail01'),
    'AC PersonDetail 02': require('./modules/PersonDetail02'),
    'AC PersonDetail 03': require('./modules/PersonDetail03'),
    'AC TeamSchedule 01': require('./modules/TeamSchedule'),
    'AC LoginHardwall 01': require('./modules/LoginHardwall'),
    'AC SplashPage 01': require('./modules/SplashPage'),
    'AC ScheduleTray 01': require('./modules/ScheduleTray'),
    'AC FighterRoster 01': require('./modules/FighterRoster'),
    'AC Library 01': require('./modules/Library'),
    'AC BundleDetail 01': require('./modules/Bundle'),
    'AC Custom 01': require('./modules/Custom'),
    'AC ContentHtml 01': require('./modules/ContentHtml'),
    'AC SearchFilter 01': require('./modules/SearchResults'),
    'AC VideoPlaylistDetail 01': require('./modules/VideoPlaylistDetail'),
    "AC Achievements 01": require("./modules/Achievements"),
    'AC Profile 02' : require('./modules/ViewNeoProfile'),
    'AC Library 02': require('./modules/LibraryByType'),
    "AC Carousel 04" : require('./modules/Carousel/carousel32'),
  }
};